export const AnnualLeavingApiUrls = {
  annualLeaving: '/employees/events/aggregate',
  annualLeavingList: '/employees/events/list',
  activeLeaving: '/employees/events/aggregate?contractEnd<' + Date.now(),
  annualLeavingUnaggregated: '/employees/events',
  annualLeavingReplacement: '/employees/contracts-replacements'
};
